import React, { useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

interface HtGoldMeproSurfaceProps {
  children: React.ReactNode
  /** Hide back on entry pages that already feel like “home” of a section */
  showBack?: boolean
  /** Override fallback when browser history cannot go back */
  fallbackTo?: string
}

/** Pages that already render their own back / “กลับหน้าหลัก” control */
const PAGE_OWNED_BACK = new Set([
  '/lobby-huay/yeekee',
  '/lobby-huay/lottery-terms',
  '/lobby-huay/bet',
  '/lobby-huay/yeekee/bet',
])

function defaultFallback(pathname: string): string {
  if (pathname.startsWith('/reward')) return '/dashboard'
  if (pathname.startsWith('/promotion')) return '/dashboard'
  if (pathname.startsWith('/howto')) return '/dashboard'
  if (pathname.startsWith('/history')) return '/dashboard'
  if (pathname.startsWith('/affiliate')) return '/dashboard'
  if (pathname.startsWith('/cashback')) return '/dashboard'
  if (pathname.startsWith('/member')) return '/dashboard'
  if (pathname.startsWith('/live-tv')) return '/dashboard'
  if (pathname.startsWith('/points')) return '/dashboard'
  if (pathname.startsWith('/topup') || pathname.startsWith('/withdraw')) return '/dashboard'
  if (pathname.startsWith('/lobby-casino')) return '/dashboard'
  if (pathname.startsWith('/lobby-huay')) {
    if (pathname === '/lobby-huay' || pathname === '/lobby-huay/listall') return '/'
    return '/lobby-huay/listall'
  }
  if (pathname.startsWith('/register')) return '/'
  return '/dashboard'
}

const HtGoldMeproSurface: React.FC<HtGoldMeproSurfaceProps> = ({
  children,
  showBack = true,
  fallbackTo,
}) => {
  const navigate = useNavigate()
  const location = useLocation()
  const fallback = useMemo(
    () => fallbackTo || defaultFallback(location.pathname),
    [fallbackTo, location.pathname],
  )
  const effectiveShowBack = showBack && !PAGE_OWNED_BACK.has(location.pathname)

  const handleBack = () => {
    const idx = (window.history.state as { idx?: number } | null)?.idx
    if (typeof idx === 'number' && idx > 0) {
      navigate(-1)
      return
    }
    navigate(fallback)
  }

  return (
    <div className="htg-mepro-surface">
      {effectiveShowBack ? (
        <div className="htg-mepro-backbar">
          <button type="button" className="htg-mepro-back" onClick={handleBack}>
            <span className="htg-mepro-back__icon" aria-hidden>
              <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
                <path d="M15 18l-6-6 6-6" />
              </svg>
            </span>
            <span>ย้อนกลับ</span>
          </button>
        </div>
      ) : null}
      {children}
    </div>
  )
}

export default HtGoldMeproSurface
